import { ExpandedStation, Station, StationData, StationType } from 'pages/Map/types';
import { BigJunctureStation, DecisionStation, InfoStation, SubZoneStation, TransitionStation, ZoneEndStation, ZoneStartStation } from '.';
import { RefObject, useEffect } from 'react';
import { MapStateRefObject } from 'context/ZoneContext';

export const buildStation = (station: StationData) => {
    const { type } = station;

    switch (type) {
        case StationType.Decision:
            return new DecisionStation(station);

        case StationType.BigJuncture:
            return new BigJunctureStation(station);

        case StationType.Info:
            return new InfoStation(station);

        case StationType.SubZone:
            return new SubZoneStation(station);

        case StationType.Transition:
            return new TransitionStation(station);

        case StationType.ZoneEnd:
            return new ZoneEndStation(station);

        case StationType.ZoneStart:
            return new ZoneStartStation(station);
    }
};

export const useExpandedStationOutsideClickAlerter = (
    ref: RefObject<HTMLDivElement>,
    outsideClickHandler: () => void,
    mapState: MapStateRefObject,
    { exceptionEleIds, exceptionEleClass }: { exceptionEleIds?: string | string[]; exceptionEleClass?: string }
) => {
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (!ref.current || mapState.current.isPanning) {
                return;
            }

            if (exceptionEleIds) {
                const isClickOnExceptionElement = (id: string) => {
                    const ele = document.getElementById(id);
                    if (ele && ele.contains(event.target)) return true;
                };

                if (Array.isArray(exceptionEleIds)) {
                    if (exceptionEleIds.some(isClickOnExceptionElement)) return;
                } else {
                    if (isClickOnExceptionElement(exceptionEleIds)) return;
                }
            }

            if (exceptionEleClass) {
                const elements = document.getElementsByClassName(exceptionEleClass);
                const elementsArray = Array.from(elements);
                if (elementsArray.some(ele => ele.contains(event.target))) return;
            }

            const { bottom, left, top, right } = ref.current.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;

            if (!(x >= left && x <= right && y >= top && y <= bottom) && !(event.target.nodeName === 'path')) {
                outsideClickHandler();
            }
        };
        const map = document.getElementById('zone-map');
        if (!map) {
            return;
        }

        map.addEventListener('click', handleClickOutside);
        return () => {
            map.removeEventListener('click', handleClickOutside);
        };
    }, [ref, mapState]);
};

export const isTypeOfExpandedStation = (station: Station): station is NonNullable<ExpandedStation> => {
    return station instanceof BigJunctureStation || station instanceof SubZoneStation;
};
